import { render } from "./TradeHistory.vue?vue&type=template&id=7377ddf5&scoped=true"
import script from "./TradeHistory.vue?vue&type=script&lang=js"
export * from "./TradeHistory.vue?vue&type=script&lang=js"

import "./TradeHistory.vue?vue&type=style&index=0&id=7377ddf5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7377ddf5"]])

export default __exports__